// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Billing Account API
 * Endpoints for managing billing accounts, marketplaces, payment processors, and entitlements.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Type of the entitlement
 * @export
 */
export const EntitlementType = {
  Trial: 'trial',
  Poc: 'poc',
  Payg: 'payg',
  Prepaid: 'prepaid',
  DevRel: 'dev-rel',
  TrialExtension: 'trial-extension',
} as const;
export type EntitlementType =
  (typeof EntitlementType)[keyof typeof EntitlementType];

export function instanceOfEntitlementType(value: any): boolean {
  for (const key in EntitlementType) {
    if (Object.prototype.hasOwnProperty.call(EntitlementType, key)) {
      if (EntitlementType[key as keyof typeof EntitlementType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EntitlementTypeFromJSON(json: any): EntitlementType {
  return EntitlementTypeFromJSONTyped(json, false);
}

export function EntitlementTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EntitlementType {
  return json as EntitlementType;
}

export function EntitlementTypeToJSON(value?: EntitlementType | null): any {
  return value as any;
}

export function EntitlementTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EntitlementType {
  return value as EntitlementType;
}
